<form #form class="col-12">
  <div class="info-titlebar">
    <span class="label-section">
      <span class="label">Disposition Info</span>
      @if (!!disposition.permission?._edit) {
        <button
          type="button"
          class="save-button"
          (click)="saveDisposition()"
          >
          <mat-icon>save</mat-icon>
        </button>
      }
      @if (
        !!disposition.permission?._delete && disposition.is_final !== true
        ) {
        <button
          type="button"
          class="delete-button"
          (click)="deleteDisposition()"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
    </span>
    <simple-checkbox
      [name]="'is_final'"
      [label]="'Final'"
      [disabled]="!disposition.permission?._edit"
      [checked]="disposition.is_final"
      (checkedChange)="
        disposition.is_final = !disposition.is_final;
        readOnly =
          disposition.is_final === true || !disposition.permission?._edit
      "></simple-checkbox>
  </div>
  <div class="row space-between align-top gutters">
    <ul class="col-md-6 dual-column-table row">
      <li class="col-md-6">
        <label for="purchaser">Purchaser</label>
        @if (!readOnly) {
          <freeform-org-search
          [value]="
            disposition.organization
              ? disposition.organization.name
              : disposition.purchaser
          "
            (searchChanged)="resetOrg($event)"
          (selectedOrg)="selectOrg($event)"></freeform-org-search>
        }
        <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value: disposition.organization
                ? disposition.organization.name
                : disposition.purchaser
            }
          ">
      </ng-container>
      <input
        type="hidden"
        name="organization_id"
        [value]="$safeNavigationMigration(disposition.organization?.id)" />
    </li>
    <li class="col-md-6">
      <label for="">Related Party</label>
      @if (!readOnly) {
        <nullable-boolean
          [(value)]="disposition.related_party"
        [name]="'related_party'"></nullable-boolean>
      }
      <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value:
                disposition.related_party === null
                  ? null
                  : disposition.related_party
                  ? 'Yes'
                  : 'No'
            }
          ">
    </ng-container>
  </li>
  <li class="col-md-6">
    <label for="">Disposition Status</label>
    <span>
      <select
        name="disposition_status_id"
        [disabled]="readOnly"
        [ngModel]="dispositionStatus$ | async"
        (change)="changeDispositionStatus($event)">
        <option [value]="null">&mdash;</option>
        @for (
          dispositionStatus of dispositionsService.dispositionStatuses$
          | async
          ; track
          dispositionStatus) {
          <option
            [value]="dispositionStatus.id"
              [attr.data-status-sequence]="
                dispositionStatus.statusSequenceDetails
                  ? dispositionStatus.statusSequenceDetails[0]
                      .status_sequence_id
                  : ''
              ">
            {{ dispositionStatus.name }}
          </option>
        }
      </select>
    </span>
  </li>
  <li class="col-md-6">
    <label for="disposition_type_id">Disposition Type</label>
    <span>
      <select
        name="disposition_type_id"
        id=""
        [disabled]="readOnly"
        [(ngModel)]="disposition.disposition_type_id">
        <option value="">&mdash;</option>
        @for (
          dispositionType of dispositionsService.dispositionTypes$
          | async
          ; track
          dispositionType) {
          <option
            [value]="dispositionType.id">
            {{ dispositionType.name }}
          </option>
        }
      </select></span
      >
    </li>
    <li class="col-md-6">
      <disposition-date
        name="closing_date"
        [disabled]="readOnly"
        label="Closing Date"
        pipelineMilestoneName="Closed"
        [disposition]="disposition"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <disposition-date
        label="Effective Closing Date"
        [disabled]="readOnly"
        name="effective_closing_date"
        dateTypeName="Effective Disposition Closed"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <disposition-date
        label="Disposition Committee Date"
        [disabled]="readOnly"
        name="disposition_committee_date"
        pipelineMilestoneName="Disposition Committee Completed"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <label for="disposition_bov_id">Broker's Opinion of Value</label>
      <select
        name="disposition_bov_id"
        [disabled]="readOnly"
        [(ngModel)]="disposition.disposition_bov_id">
        <option [value]="null">&mdash;</option>
        @for (
          dispositionBov of dispositionsService.dispositionBovs$ | async
          ; track
          dispositionBov) {
          <option
            [value]="dispositionBov.id">
            {{ dispositionBov.name }}
          </option>
        }
      </select>
    </li>
    <li class="col-md-6">
      <label for="recapture_bond">Recapture Bond</label>
      @if (!readOnly) {
        <nullable-boolean
          [(value)]="disposition.recapture_bond"
        [name]="'recapture_bond'"></nullable-boolean>
      }
      <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value:
                disposition.recapture_bond === null
                  ? null
                  : disposition.recapture_bond
                  ? 'Yes'
                  : 'No'
            }
          ">
    </ng-container>
  </li>
  <li class="col-md-6">
    <label for="recapture_exposure">Recapture Exposure</label>
    @if (!readOnly) {
      <input
        type="number"
        step=".0001"
        name="recapture_exposure"
        [(ngModel)]="disposition.recapture_exposure" />
    }
    <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value:
                (disposition.recapture_exposure
                | currency: 'USD':'symbol':'1.0-0')
            }
          ">
  </ng-container>
</li>
<li class="col-md-6">
  <label for="crea_rofr">CREA ROFR</label>
  @if (!readOnly) {
    <nullable-boolean
      [(value)]="disposition.crea_rofr"
    [name]="'crea_rofr'"></nullable-boolean>
  }
  <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value:
                disposition.crea_rofr === null
                  ? null
                  : disposition.crea_rofr
                  ? 'Yes'
                  : 'No'
            }
          ">
</ng-container>
</li>
<li class="col-md-6">
  <label for="monitoring_compliance">Monitoring Compliance</label>
  @if (!readOnly) {
    <nullable-boolean
      [(value)]="disposition.monitoring_compliance"
    [name]="'monitoring_compliance'"></nullable-boolean>
  }
  <ng-container
          *ngTemplateOutlet="
            readOnly ? valueSpan : nothing;
            context: {
              value:
                disposition.monitoring_compliance === null
                  ? null
                  : disposition.monitoring_compliance
                  ? 'Yes'
                  : 'No'
            }
          ">
</ng-container>
</li>
</ul>
<ul class="col-md-6 dual-column-table row">
  <li class="col-md-6">
    <label for="disposition_legal_status_id">Legal Status</label>
    <span>
      <select
        name="disposition_legal_status_id"
        [disabled]="readOnly"
        [(ngModel)]="disposition.disposition_legal_status_id">
        <option [value]="null">&mdash;</option>
        @for (
          dispositionLegalStatus of dispositionsService.dispositionLegalStatuses$
          | async
          ; track
          dispositionLegalStatus) {
          <option
            [value]="dispositionLegalStatus.id">
            {{ dispositionLegalStatus.name }}
          </option>
        }
      </select></span
      >
    </li>
    <li class="col-md-6">
      <label for="disposition_yield_request_status_id">
        Yield Request Status
      </label>
      <span>
        <select
          name="disposition_yield_request_status_id"
          [disabled]="readOnly"
          [(ngModel)]="disposition.disposition_yield_request_status_id">
          <option [value]="null">&mdash;</option>
          @for (
            dispositionYieldRequestStatus of dispositionsService.dispositionYieldRequestStatuses$
            | async
            ; track
            dispositionYieldRequestStatus) {
            <option
              [value]="dispositionYieldRequestStatus.id">
              {{ dispositionYieldRequestStatus.name }}
            </option>
          }
        </select>
      </span>
    </li>
    <li class="col-md-6">
      <span class="field_label">Board Consent</span>
      <span>
        <simple-checkbox
          name="board_consent_na"
          label="N/A"
          [disabled]="readOnly"
          [checked]="disposition.board_consent_na"
            (checkedChange)="
              disposition.board_consent_na = !disposition.board_consent_na
            ">
        </simple-checkbox>
      </span>
    </li>
    <li class="col-md-6"></li>
    <li class="col-md-6">
      <disposition-date
        label="Board Consent Sent"
        [disabled]="readOnly"
        name="board_consent_sent_date"
        dateTypeName="Disposition Board Consent Sent"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <disposition-date
        label="Board Consent Received"
        [disabled]="readOnly"
        name="board_consent_received_date"
        dateTypeName="Disposition Board Consent Received"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <span class="field_label">Investor Consent</span>
      <span>
        <simple-checkbox
          [name]="'investor_consent_na'"
          [disabled]="readOnly"
          [label]="'N/A'"
          [checked]="disposition.investor_consent_na"
            (checkedChange)="
              disposition.investor_consent_na = !disposition.investor_consent_na
            "></simple-checkbox>
      </span>
    </li>
    <li class="col-md-6"></li>
    <li class="col-md-6">
      <disposition-date
        label="Investor Consent Sent"
        [disabled]="readOnly"
        name="investor_consent_sent_date"
        dateTypeName="Disposition Investor Consent Sent"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
    <li class="col-md-6">
      <disposition-date
        label="Investor Consent Received"
        [disabled]="readOnly"
        name="investor_consent_received_date"
        dateTypeName="Disposition Investor Consent Received"
        [dateTypes]="dispositionsService.dateTypes$ | async"
        [dateClass]="dispositionsService.dateClass$ | async"
        [statuses]="dispositionsService.dispositionStatuses$ | async"
        [disposition]="disposition"
      (dateChanged)="updateDate($event)"></disposition-date>
    </li>
  </ul>
</div>
</form>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
